import { getPositions } from '../../utils/getPositionsUtils';
import { ConfigRulesProps } from './config.types';

export const russianConfig = [
  'С', 'Е', 'Й', 'Ч', 'А', 'С', 'Г', 'П', 'Я', 'Т', 'Ь',
  'О', 'Д', 'И', 'Н', 'Ы', 'Ч', 'Е', 'Т', 'Ы', 'Р', 'И',
  'В', 'О', 'С', 'Е', 'М', 'Ь', 'Ш', 'Е', 'С', 'Т', 'Ь',
  'Д', 'В', 'А', 'В', 'Д', 'Е', 'С', 'Я', 'Т', 'Ь', 'Е',
  'О', 'Д', 'И', 'Н', 'Н', 'А', 'Д', 'Ц', 'А', 'Т', 'Ь',
  'П', 'Д', 'В', 'Е', 'Н', 'А', 'Д', 'Ц', 'А', 'Т', 'Ь',
  'Д', 'Е', 'В', 'Я', 'Т', 'Ь', 'Й', 'Ш', 'Т', 'Р', 'И',
  'Ч', 'А', 'С', 'А', 'Ф', 'Ч', 'А', 'С', 'О', 'В', 'Ь',
  'У', 'О', 'Р', 'Т', 'Р', 'И', 'Д', 'Ц', 'А', 'Т', 'Ь',
  'П', 'Я', 'Т', 'Н', 'А', 'Д', 'Ц', 'А', 'Т', 'Ь', 'О',
  'Д', 'В', 'А', 'Д', 'Ц', 'А', 'Т', 'Ь', 'Р', 'Б', 'М',
  'С', 'О', 'Р', 'О', 'К', 'Д', 'Е', 'С', 'Я', 'Т', 'Ь',
  'С', 'П', 'Я', 'Т', 'Ь', 'Д', 'Е', 'С', 'Я', 'Т', 'Ь',
  'П', 'Æ', 'Т', 'Ь', 'Р', 'Б', 'М', 'И', 'Н', 'У', 'Т',
];

export const russianConfigRules: ConfigRulesProps = {
  start: getPositions(['сейчас'], russianConfig),
  end: [],
  one: getPositions(['один', 'час'], russianConfig),
  two: getPositions(['два', 'часа'], russianConfig, { preferFirst: true }),
  three: getPositions(['три', 'часа'], russianConfig, { preferFirst: true }),
  four: getPositions(['четыри', 'часа'], russianConfig),
  five: getPositions(['пять', 'часов'], russianConfig, { preferFirst: true }),
  six: getPositions(['шесть', 'часов'], russianConfig),
  seven: getPositions(['семь', 'часов'], russianConfig),
  eight: getPositions(['восемь', 'часов'], russianConfig),
  nine: getPositions(['девять', 'часов'], russianConfig),
  ten: getPositions(['десять', 'часов'], russianConfig, { preferFirst: true }),
  eleven: getPositions(['одиннадцать', 'часов'], russianConfig),
  twelve: getPositions(['двенадцать', 'часов'], russianConfig),
  fiveAfter: getPositions(['пÆть', 'минут'], russianConfig),
  tenAfter: getPositions(['десять', 'минут'], russianConfig),
  quarterAfter: getPositions(['пятнадцать', 'минут'], russianConfig),
  twentyAfter: getPositions(['двадцать', 'минут'], russianConfig),
  fiveBeforeHalf: getPositions(['двадцать', 'пÆть', 'минут'], russianConfig),
  half: getPositions(['тридцать', 'минут'], russianConfig),
  fiveAfterHalf: getPositions(['тридцать', 'пÆть', 'минут'], russianConfig),
  fiveBefore: getPositions(['пятьдесят', 'пÆть', 'минут'], russianConfig),
  tenBefore: getPositions(['пятьдесят', 'минут'], russianConfig),
  quarterBefore: getPositions(['сорок', 'пÆть', 'минут'], russianConfig),
  twentyBefore: getPositions(['сорок', 'минут'], russianConfig),
};
